module.exports = __webpack_public_path__ + "img/台灣第一家.a3405d91.svg";